
import { usePerformanceStage } from "@/hooks/usePerformanceStage";

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const TabNavigation = ({ activeTab, onTabChange }: TabNavigationProps) => {
  const { config: performanceConfig } = usePerformanceStage();

  return (
    <div className="bg-secondary/30 rounded-lg">
      <div className="flex border-b border-primary/20">
        <button 
          onClick={() => onTabChange("personal-goals")} 
          className={`px-6 py-3 text-sm font-medium transition-colors ${
            activeTab === "personal-goals" 
              ? "text-primary border-b-2 border-primary bg-primary/10" 
              : "text-gray-400 hover:text-white"
          } ${!performanceConfig.appraisal_stage ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={!performanceConfig.appraisal_stage}
        >
          Personal Goals
        </button>
        <button 
          onClick={() => onTabChange("manage-team-members")} 
          className={`px-6 py-3 text-sm font-medium transition-colors ${
            activeTab === "manage-team-members" 
              ? "text-primary border-b-2 border-primary bg-primary/10" 
              : "text-gray-400 hover:text-white"
          } ${!performanceConfig.appraisal_stage ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={!performanceConfig.appraisal_stage}
        >
          Manage Team Members
        </button>
      </div>
    </div>
  );
};

export default TabNavigation;
